<template>
  <div class="content">
    <PageHeader :breadcrumbLinks="breadcrumbLinks" :title="'Whatsapp'" :subtitle="$tc('app.report', 2)" />
    <div class="page-content container-fluid">
      <div class="row">
        <div class="col-lg-12 col-xl-12">
          <div class="card card-tabs">
            <div class="card-header">
              <ul class="nav nav-tabs">
                <li class="nav-item" role="presentation">
                  <router-link
                    :to="{ name: 'AdminWhatsappStatReport' }"
                    class="nav-link"
                    replace
                    ><span class="material-symbols-outlined"> query_stats </span
                    >{{ $tc('app.stats', 2) }}</router-link
                  >
                </li>
                <li class="nav-item" role="presentation">
                  <router-link
                    :to="{ name: 'AdminWhatsappHistoryReport' }"
                    class="nav-link"
                    replace
                    ><span class="material-symbols-outlined"> history </span
                    >{{ $t('app.history') }}</router-link
                  >
                </li>
                <!-- <li class="nav-item" role="presentation">
                  <router-link
                    :to="{ name: 'WhatsAppMetaUsageReport' }"
                    class="nav-link"
                    replace
                    ><span class="material-symbols-outlined">
                      insert_chart </span
                    >{{ $tc('app.usage', 1) }}</router-link
                  >
                </li> -->
               <!-- <li class="nav-item" role="presentation">
                  <router-link
                    :to="{ name: 'WhatsAppMetaCampaignReport' }"
                    class="nav-link"
                    replace
                    ><span class="material-symbols-outlined"> campaign </span
                    >{{ $tc('app.campaign', 2) }}</router-link
                  >
                </li> -->
                <li class="nav-item" role="presentation">
                  <router-link :to="{ name: 'AdminWhatsappSinteticReport' }" class="nav-link" replace>
                    <span class="material-symbols-outlined">manage_accounts</span>
                    <span>Gestão</span>
                  </router-link>
                </li>
                <div class="opts_card">
                  <a
                    style="display: flex; align-items: center"
                    href="javascript:void(0)"
                    @click="showFilter"
                    ><span class="material-symbols-outlined title">
                      filter_list
                    </span></a
                  >
                  <a
                    style="display: flex; align-items: center"
                    href="javascript:void(0)"
                    @click="reload"
                    ><span class="material-symbols-outlined title">
                      refresh
                    </span></a
                  >
                  <form class="form-inline calendar_form">
                    <date-range-picker
                      class="form-control"
                      :format="'YYYY-MM-DD'"
                      :options="options"
                      @change="changeDate"
                    />
                  </form>
                  <y-date-picker :type="'icon'" :iconClass="'calendar_icon'" :options="optionCalendar" :format="'YYYY-MM-DD'" @change="changeDate"></y-date-picker>
                  <dropdown tag="span">
                    <template #text>
                      <i class="fas fa-file-export title"></i>
                    </template>
                    <template #items>
                      <a
                        class="dropdown-item"
                        href="javascript:void(0)"
                        @click="exportData('csv')"
                        >CSV</a
                      >
                      <a
                        v-if="$route.name === 'WhatsappStatReport'"
                        class="dropdown-item"
                        href="javascript:void(0)"
                        @click="exportData('png')"
                        >PNG</a
                      >
                      <a
                        v-if="$route.name === 'WhatsappStatReport'"
                        class="dropdown-item"
                        href="javascript:void(0)"
                        @click="exportData('svg')"
                        >SVG</a
                      >
                      <a
                        v-if="$route.name !== 'WhatsappStatReport'"
                        class="dropdown-item"
                        href="javascript:void(0)"
                        @click="exportData('xlsx')"
                        >XLSX</a
                      >
                      <a
                        v-if="$route.name !== 'WhatsappStatReport'"
                        class="dropdown-item"
                        href="javascript:void(0)"
                        @click="exportData('pdf')"
                        >PDF</a
                      >
                    </template>
                  </dropdown>
                </div>
              </ul>
            </div>
            <div class="card-body block-el">
              <router-view
                ref="view"
                :filters="form.filters"
                :startDate="form.date.gte"
                :endDate="form.date.lte"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal ref="filter-modal" title="Filtros" size="xl">
      <h2 class="text-center m-b-10">Status</h2>
      <div class="d-flex justify-content-between">
        <div class="custom-control custom-checkbox custom-control-inline">
          <input
            type="checkbox"
            id="acceptedCheckbox"
            name="customcheckboxInline1"
            class="custom-control-input"
            value="accepted"
            v-model="filter.status"
          />
          <label class="custom-control-label" for="acceptedCheckbox">{{
            $tc('app.accepted')
          }}</label>
        </div>
        <div class="custom-control custom-checkbox custom-control-inline">
          <input
            type="checkbox"
            id="queuedCheckbox"
            name="customcheckboxInline1"
            class="custom-control-input"
            value="queued"
            v-model="filter.status"
          />
          <label class="custom-control-label" for="queuedCheckbox">{{
            $tc('app.queued')
          }}</label>
        </div>
        <div class="custom-control custom-checkbox custom-control-inline">
          <input
            type="checkbox"
            id="sendingCheckbox"
            name="customcheckboxInline1"
            class="custom-control-input"
            value="sending"
            v-model="filter.status"
          />
          <label class="custom-control-label" for="sendingCheckbox">{{
            $tc('app.sending')
          }}</label>
        </div>
        <div class="custom-control custom-checkbox custom-control-inline">
          <input
            type="checkbox"
            id="failedCheckbox"
            name="customcheckboxInline1"
            class="custom-control-input"
            value="failed"
            v-model="filter.status"
          />
          <label class="custom-control-label" for="failedCheckbox">{{
            $tc('app.failed')
          }}</label>
        </div>
        <div class="custom-control custom-checkbox custom-control-inline">
          <input
            type="checkbox"
            id="sentCheckbox"
            name="customcheckboxInline1"
            class="custom-control-input"
            value="sent"
            v-model="filter.status"
          />
          <label class="custom-control-label" for="sentCheckbox">{{
            $tc('app.sent')
          }}</label>
        </div>
        <div class="custom-control custom-checkbox custom-control-inline">
          <input
            type="checkbox"
            id="deliveredCheckbox"
            name="customcheckboxInline1"
            class="custom-control-input"
            value="delivered"
            v-model="filter.status"
          />
          <label class="custom-control-label" for="deliveredCheckbox">{{
            $tc('app.delivered')
          }}</label>
        </div>
        <div class="custom-control custom-checkbox custom-control-inline">
          <input
            type="checkbox"
            id="receivedCheckbox"
            name="customcheckboxInline1"
            class="custom-control-input"
            value="received"
            v-model="filter.status"
          />
          <label class="custom-control-label" for="receivedCheckbox">{{
            $tc('app.received')
          }}</label>
        </div>
      </div>
      <div class="row m-t-30">
        <div class="col-3">
          <h2 class="text-center">Remetente</h2>
          <div class="form-group">
            <input
              type="text"
              class="form-control"
              id="demoTextInput1"
              v-model="filter.from"
            />
          </div>
        </div>
        <div class="col-3">
          <h2 class="text-center">Destinatario</h2>
          <div class="form-group">
            <input
              type="text"
              class="form-control"
              id="demoTextInput1"
              v-model="filter.to"
            />
          </div>
        </div>
        <div class="col-3">
          <h2 class="text-center">Campanha</h2>
          <div class="form-group">
            <select class="form-control select-agent" v-model="filter.campaign">
              <option value="" selected>Escolha uma Campanha</option>
              <option
                v-for="campaign in campaigns"
                :key="campaign.id"
                :value="campaign.id"
              >{{ campaign.name ? campaign.name : campaign.interface }}</option>
            </select>
          </div>
        </div>
        <div class="col-3">
          <h2 class="text-center">Cliente</h2>
          <div class="form-group">
            <select-input
              :options="customers"
              v-model="filter.account_id.in"
              label="name"
              :reduce="(field) => field.id"
            ></select-input>
          </div>
        </div>
      </div>

      <template #footer>
        <div class="d-flex justify-content-between w-100">
          <button
            @click="cleanFilter"
            type="submit"
            class="btn btn-primary btn-outline"
          >
            {{ $t('app.clean') }}
          </button>
          <button @click="applyFilter" type="submit" class="btn btn-primary">
            {{ $t('app.apply') }}
          </button>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
// @ is an alias to /src
import moment from 'moment';
import PageHeader from '@/components/rebranding/PageHeader.vue';
import Dropdown from '@/components/Dropdown';
import Modal from '@/components/Modal';
import Tab from '@/directives/Tab';
import WhatsService from '@/services/whatsapp.service';
import YDatePicker from '@/components/DatePicker/YDatePicker.vue';
import SelectInput from '@/components/SelectInput.vue';
import CustomerService from '@/services/customer.service';

export default {
  name: 'WhatsappDashboard',
  components: {
    PageHeader,
    Dropdown,
    Modal,
    YDatePicker,
    SelectInput,
    // Card,
  },
  directives: {
    Tab,
  },
  data() {
    return {
      breadcrumbLinks: {
        1: '/whatsapp/reports/history',
        2: '/whatsapp/reports/history',
      },
      optionCalendar: {
        autoApply: true,
        startDate: moment().format('YYYY-MM-DD'),
      },
      filter: {
        account_id: {
          in: [],
        },
        status: [],
        from: '',
        to: '',
        campaign: '',
        page: 1,
        gte: moment().format('YYYY-MM-DD'),
        lte: moment().add(1, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss'),
      },
      campaigns: [],
      customers: [],
      options: {
        timePicker: false,
        autoApply: true,
        className: 'form-control',
        startDate: moment().format('DD/MM/YYYY'),
        maxSpan: {
          days: 31,
        },
        locale: {
          format: 'DD/MM/YYYY',
          daysOfWeek: ['Do', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sa'],
          monthNames: [
            'Jan',
            'Fev',
            'Mar',
            'Abr',
            'Mai',
            'Jun',
            'Jul',
            'Ago',
            'Set',
            'Otu',
            'Nov',
            'Dez',
          ],
        },
      },
      form: {
        date: {
          gte: moment().format('YYYY-MM-DD'),
          lte: moment().add(1, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        },
        filters: {
          status: [],
          account_id: {
            in: [],
          },
          from: '',
          to: '',
          campaign: '',
          gte: moment().format('YYYY-MM-DD'),
          lte: moment().add(1, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss'),
          page: 1,
        },
      },
    };
  },
  created() {
    this.getCampaign();
    this.fetchCustomers();
  },
  // Pai
  methods: {
    showFilter() {
      this.$refs['filter-modal'].toggle();
    },
    reload() {
      this.$refs.view.fetch(1);
    },
    applyFilter() {
      this.form.filters = this.filter;
      this.$nextTick(() => {
        this.reload();
      });
    },
    getCampaign() {
      WhatsService.getNewCampaigns({}).then(
        (response) => {
          this.campaigns = response;
          console.log('FETCH Campanha', response);
        },
        (error) => {
          this.$toast.show({
            title: 'Erro',
            content: 'Erro interno, por favor tente novamente mais tarde.',
            type: 'danger',
          });
          console.log(JSON.stringify(error.response.data));
        },
      );
    },
    cleanFilter() {
      this.filter = {
        carrier: [],
        status: [],
        from: '',
        to: '',
        segments: '',
        campaign: '',
        page: 1,
      };
      this.form.filter = {};
      this.reload();
    },
    /* changeDate(date) {
      console.log(date);
      if (date) {
        this.form.filters.gte = moment(date[0]).format('YYYY-MM-DD');
        this.form.filters.lte = moment(date[1]).format('YYYY-MM-DD 23:59:59');

        this.$nextTick(() => {
          this.reload();
        });
      }
    }, */
    changeDate(date) {
      console.log(date);
      if (date) {
        const startDate = moment(date[0]).startOf('day');
        const endDate = moment(date[1]).startOf('day');

        // Verificar se as datas são iguais
        if (startDate.isSame(endDate, 'day')) {
          endDate.add(1, 'day'); // Adicionar um dia à segunda data
        }

        this.form.filters.gte = startDate.format('YYYY-MM-DD');
        this.form.filters.lte = endDate.format('YYYY-MM-DD HH:mm:ss');

        this.$nextTick(() => {
          this.reload();
        });
      }
    },
    exportData(format) {
      this.$refs.view.exportData(format);
    },
    fetchCustomers() {
      CustomerService.getCustomers().then(
        (customers) => {
          this.customers = customers;
        },
        (error) => {
          this.content = error;
        },
      );
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~primevue/resources/themes/saga-blue/theme.css';
@import '~primevue/resources/primevue.min.css';

.table-responsive {
  min-height: 150px;
}

/* Rebranding */
.card.card-tabs .card-header .nav.nav-tabs {
  width: 100%;
  padding: 0 1rem;
  gap: 2.5rem;
}
.card.card-tabs .card-header .nav.nav-tabs li a {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 1.4rem 0.7rem 1.3rem;
  color: var(--clr-light-2);
}
.nav.nav-tabs .nav-item .nav-link.router-link-exact-active {
  color: var(--clr-yup-purple) !important;
  border-bottom: solid 2px var(--clr-yup-purple);
}

.nav.nav-tabs .nav-item .nav-link.router-link-exact-active i {
  color: var(--clr-yup-purple) !important;
}

.card.card-tabs .card-header .nav.nav-tabs li a i {
  font-size: 24px;
}

.nav-tabs .nav-item {
  margin-bottom: -2px;
}
.nav-tabs {
  border-bottom: 2px solid rgba(210, 221, 234, 0.5);
}

.rebranding .card .opts_card i {
  font-size: 22px;
  transition: 0.5s;
  padding: 5px;
}

.rebranding .card .opts_card i:hover {
  background-color: var(--background-icon-hover);
  border-radius: 5px;
}

.calendar_form {
  position: absolute;
  right: 70px;
  width: 38px;
  opacity: 0;
}

.calendar_form:hover ~ .calendar_icon,
.calendar_form:focus-within ~ .calendar_icon {
  background-color: var(--background-icon-hover);
  border-radius: 5px;
}

.calendar_form input {
  cursor: pointer;
  width: 38px;
}
.card {
  box-shadow: none !important;
}
.nav-tabs {
  border-bottom: 4px solid #6B23DC3D;
}
.nav.nav-tabs .nav-item .nav-link.router-link-exact-active {
  border-bottom: solid 4px var(--clr-yup-purple);
}
.nav-tabs .nav-item {
  margin-bottom: -4px;
}
::v-deep .icon-calendar {
  color: var(--gray-font-color) !important;
}
</style>
